import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)
Vue.use(Vuetify)

export default new Vuetify({})
